/* eslint-disable no-alert */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Fade from 'react-reveal/Fade';
import Pulse from 'react-reveal/Pulse';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { useTranslation } from 'react-i18next';
import Hero from '../components/Hero';
import Spacer from '../components/Spacer';
import Profile from '../components/Profile';
import AppointmentLinks from '../components/custom/AppointmentLinks';
import LogoLinks from '../components/custom/LogoLinks';

function Home() {
  const { t } = useTranslation();
  const randomImageNumber = Math.floor(Math.random() * 7) + 1;

  // Check if the screen width is larger than a certain threshold (e.g., 1024px)
  const isLargeScreen = window.innerWidth > 1024;

  // Choose the appropriate image based on the screen size
  const backgroundImage = isLargeScreen
    ? `./assets/background-image-${randomImageNumber}-large.webp`
    : `./assets/background-image-${randomImageNumber}.webp`;

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'LocalBusiness',
            name: 'CV Therapy - Counseling and Wellness Center',
            description: 'Welcome to CV Therapy, where we provide compassionate and professional therapy services.',
            image: 'https://cvtherapy.org/assets/logo.svg',
            '@id': 'https://cvtherapy.org',
            url: 'https://cvtherapy.org',
            telephone: '+1-760-459-5939',
            address: {
              '@type': 'PostalAddress',
              streetAddress: '41865 Boardwalk Suite 208',
              addressLocality: 'Palm Desert',
              addressRegion: 'CA',
              postalCode: '92211',
              addressCountry: 'US',
            },
            openingHoursSpecification: [
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Monday',
                opens: '08:00',
                closes: '17:00',
              },
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Tuesday',
                opens: '08:00',
                closes: '17:00',
              },
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Wednesday',
                opens: '08:00',
                closes: '15:00',
              },
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Thursday',
                opens: '08:00',
                closes: '17:00',
              },
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Saturday',
                opens: '10:00',
                closes: '14:00',
              },
            ],
            priceRange: '$$',
          })}
        </script>
      </Helmet>
      <div className="container-xxl p-0">
        <Spacer height={70} />
        <p className="bg-danger p-2 m-0 text-white">
          {t('home.alert-p1')}
          {' '}
          <a className="text-white no-underline" href="tel:7604595939">{t('phoneNumber')}</a>
          {' '}
          {t('home.alert-p2')}
          {' '}
          <a className="text-white no-underline" target="_blank" rel="noreferrer noopener" href="https://cvtherapy.clientsecure.me">{t('home.alert-p3')}</a>
          {' '}
          {t('home.alert-p4')}
        </p>
        <Hero height="30vh" image={backgroundImage}>
          <div className="d-flex justify-content-center align-items-center">
            <Pulse
              duration={5000}
              delay={1000}
              left={10}
              right={10}
              top={10}
              bottom={10}
              intensity={10}
            >
              <h1 className="text-white" style={{ textShadow: '2px 2px 4px black', fontSize: '3rem' }}>{t('home.welcome')}</h1>
            </Pulse>
          </div>
        </Hero>
        <Fade>
          <div className="row p-0 m-0">
            <div className="col-md-3">
              <Link to="/about-me" className="no-text-decoration">
                <Profile
                  image={t('aboutMe.profileImage')}
                  alt="About Me"
                  desc={t('aboutMe.profileName')}
                />
              </Link>
            </div>
            <div className="col-md-9 d-flex align-items-center">
              <div className="p-4">
                <p className="text-primary">{t('home.main')}</p>
              </div>
            </div>
          </div>
        </Fade>
        <AppointmentLinks />
        {/* add contact link to contact page */}
        <Pulse
          duration={5000}
          delay={1000}
          left={10}
          right={10}
          top={10}
          bottom={10}
          intensity={10}
        >
          <div className="d-flex justify-content-center">
            <div className="text-center mb-2 p-3">
              <Link to="/contact-me" className="text-white btn btn-primary">{t('navbar.contactMe')}</Link>
            </div>
          </div>
        </Pulse>
        <hr />
        <LogoLinks />
      </div>
    </>
  );
}

export default Home;
